module.exports = __webpack_public_path__ + "img/36059846000144.7a7bd421.png";